// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
require('jquery')
require('jquery/jquery-ujs-1.2.3')
require('./Signup/signUp')
